// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17let","col":"styles_col__2z6L_"};